"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSpacing = {
    s2: '4px',
    s1: '8px',
    m: '16px',
    l1: '20px',
    l2: '32px'
};
//# sourceMappingURL=DefaultSpacing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib-commonjs/styles/DefaultSpacing.js
// module id = 583
// module chunks = 0